import {inject, Injectable} from "@angular/core";
import {CashflowPatternGroupApiService} from "../../generated-sources/api/pattern";
import {Observable} from "rxjs";
import {CashflowPatternGroup, GroupFilterQuery} from "../../model/pattern-group/cashflow-pattern-group";

@Injectable({
    providedIn: "root"
})
export class PatternGroupService {
    private readonly api = inject(CashflowPatternGroupApiService);

    getGroups(filterQuery: GroupFilterQuery): Observable<CashflowPatternGroup[]> {
        return this.api.getCashflowPatternGroups(filterQuery);
    }

    getGroup(groupId: number): Observable<CashflowPatternGroup> {
        return this.api.getCashflowPatternGroup(groupId);
    }

    createGroup(group: CashflowPatternGroup): Observable<CashflowPatternGroup> {
        return this.api.createCashflowPatternGroup(group);
    }

    updateGroup(groupId: number, group: CashflowPatternGroup): Observable<CashflowPatternGroup> {
        return this.api.updateCashflowPatternGroup(groupId, group);
    }

    copyGroup(groupId: number, newName: string): Observable<CashflowPatternGroup> {
        return this.api.copyCashflowPatternGroup(groupId, newName);
    }

    setDefault(groupId: number): Observable<CashflowPatternGroup> {
        return this.api.setDefaultCashflowPatternGroup(groupId);
    }

    toggleFavourite(groupId: number): Observable<CashflowPatternGroup> {
        return this.api.toggleCashflowPatternGroupFavourite(groupId);
    }

    toggleArchive(groupId: number): Observable<CashflowPatternGroup> {
        return this.api.toggleCashflowPatternGroupArchive(groupId);
    }
}
